import { useState, useEffect } from "react";
import "./Style.css";
import "swiper/css";
import {
  Container,
  Row,
  Col,
  Modal,
  Button,
  ButtonGroup,
} from "react-bootstrap";
import Api from "../../components/api/Api";
import { Link, useNavigate, useParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Style from "../../UserStyle.module.css";
import TimeAgo from "../../components/timeAgo/TimeAgo";
import { useSelector } from "react-redux";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import {
  FaCheck,
  FaArrowLeft, 
  FaPause,
  FaTimes,
} from "react-icons/fa";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import axios from "axios";
import AdminHeader from "../../common/Header";
import Avatar from "../../components/notes/Avatar";
import './partnerItem.css';

const PartnerItem = () => {
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.token;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { partnerId } = useParams();
  const [subscriptionDetails, setSubscriptionDetails] = useState();
  const [paymentDetails, setPaymentDetails] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [userDetails, setUserDetails] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    whatsapp_mobile_number: "",
    service_name: "",
    city: "",
    state: "",
    documents: [],
    status: "",
    created_on: "",
    userType: {
      name: "",
    },
    active: false,
    photo: "",
    assetUrl: "",
  });

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const singlePropertyData = Api({
    url: `admin/user/id/${partnerId}`,
  });

  useEffect(() => {
    fetchData();
    fetchSubscriptionDetails();
    fetchPaymentDetails();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const responseData = await singlePropertyData.fetchDataBySingleId();
      console.log("your response data is", responseData);
      setUserDetails ({
        first_name: responseData?.data?.user?.first_name,
        last_name: responseData?.data?.user?.last_name,
        email_address: responseData?.data?.user?.email_address,
        whatsapp_mobile_number: responseData?.data?.user?.whatsapp_mobile_number,
        service_name: responseData?.data?.user?.service_name,
        city: responseData?.data?.user?.cities?.[0]?.name,
        state: responseData?.data?.user?.states?.[0]?.name,
        documents: responseData?.data?.user?.documents,
        status: responseData?.data?.user?.status,
        created_on: responseData?.data?.user?.created_on,
        userType: {
          name: responseData?.data?.user?.userType?.name,
        },
        active: responseData?.data?.user?.active,
        photo: responseData?.data?.user?.photo,
        assetUrl: responseData?.data?.assetUrl,
      })
      console.log("user values:", userDetails);

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleToggleActive = async () => {
    const newStatus = !userDetails.active;
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      active: newStatus,
    }));
    try {
      const response = await axios.put(
        `${baseUrl}/admin/user/verification/state`,
        {
          id: +partnerId,
          active_status: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.statusType === "SUCCESS") {
        showToast(`User ${newStatus ? "verified" : "verification removed"} successfully`, {
          type: "success",
        });
      } else {
        showToast(`Error updating user status. Server responded with status: `, {
          type: "error",
        });
      }
    } catch (error) {
      showToast("Some Error Occurred!", { type: "error" });
    }
  }
  
  const fetchSubscriptionDetails = async () => {
      try{
        const response = await axios.get(`${baseUrl}/payments/subscriptions/user/${partnerId}`);
        setSubscriptionDetails(response?.data);
        console.log("Subscription details:", subscriptionDetails);
      }catch (error) {
      console.error("Error fetching subscription details:", error);
    }
  };

  const fetchPaymentDetails = async () => {
      try{
        const response = await axios.get(`${baseUrl}/user/payment/id/${partnerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
        );
        setPaymentDetails(response);
        // console.log("Payment details:", paymentDetails?.data);
      }catch (error) {
      console.error("Error fetching subscription details:", error);
    }
  };

  const handleModalOpen = (action) => {
    setModalAction(action);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/partners" },
    { label: "Partner", link: "/partners", active: true },
    { label: `${userDetails?.first_name }`, link: `/partners/${partnerId}`, active: true }, 
  ];
  const handleApprove = async () => {
    try {
      const data = {
        id: +partnerId,
        first_name: userDetails?.first_name,
        last_name: userDetails?.last_name,
        status: modalAction,
      };
      const response = await axios.put(`${baseUrl}/admin/editUser`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.statusType === "SUCCESS") {
        showToast(`User ${modalAction.toLowerCase()} successfully`, {
          type: "success",
        });
        setTimeout(() => {
          navigate("/partners");
        }, 3000);
      } else {
        showToast(`Error 'approving' item. Server responded with status:`, {
          type: "success",
        });
        console.error(
          "Error 'approving' item. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      showToast("Some Error Occurred!", { type: "error" });
    } finally {
      handleModalClose();
    }
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  }; 

  return (
    <>
      <Notification />
      {isLoading ? (
        <div className={Style.spinner}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
          <div className="content-body2">
            {/* <Col md={12} className="p-3"></Col> */}
            <Container>
              <BreadCrumb items={breadcrumbItems} />

              <Row>
                <Col lg={3} md={4} sm={12}>
                  <AdminHeader />
                </Col>
                <Col lg={9} md={8} sm={12} className="mainCardAreaInside">
                  <div className="card rounded-3 mb-4" style={{maxWidth: "800px"}}>
                  {userDetails ? (
                    <div className="container ">
                      <div className="card shadow border-0 rounded-4 overflow-hidden">
                        
                        {/* profile header */}
                        <div className="container-fluid bg-light rounded-4 shadow-sm py-4 px-3 px-md-5 mb-4">
                          <div className="row align-items-center">
                            {/* Avatar */}
                            <div className="col-12 col-md-auto text-center mb-3 mb-md-0">
                              <Avatar
                                icon={userDetails.first_name}
                                src={userDetails.photo}
                                size={100}
                                className="rounded-circle shadow-sm"
                              />
                            </div>

                            {/* User Info */}
                            <div className="col text-center text-md-start">
                              <div className="d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-between">
                                {/* Name & Type */}
                                <div>
                                  <h2 className="mb-1">
                                    {userDetails.first_name} {userDetails.last_name}
                                    {userDetails.status && (
                                      <span
                                        className={`badge ms-2 ${
                                          userDetails.status === 'NEW' ? 'bg-warning text-dark' : 'bg-secondary'
                                        }`}
                                      >
                                        {userDetails.status}
                                      </span>
                                    )}
                                  </h2>
                                  <p className="text-muted mb-0">{userDetails.userType?.name || 'User'}</p>
                                  <p className="text-muted" style={{ fontSize: '0.9rem' }}>
                                    Joined <TimeAgo timestamp={userDetails.created_on} />
                                  </p>
                                </div>

                                {/* <div className="d-flex flex-column align-items-center">
                                  <div
                                    className={`simple-toggle ${userDetails.active ? 'active' : 'deactive'}`}
                                    onClick={handleToggleActive}
                                    role="switch"
                                    aria-checked={userDetails.active}
                                  >
                                    <div className="thumb"></div>
                                  </div>

                                  <span
                                    className={`status-label mt-2 ${userDetails.active ? 'active' : 'deactive'}`}
                                  >
                                    {userDetails.active ? 'Verified' : 'Unverified'}
                                  </span>
                                </div> */}

                              </div>
                            </div>
                          </div>
                        </div>

                        {/* User Details */}
                        <div className="card-body px-4 ">
                          <div className="row gy-4">

                            {/* Contact Info */}
                            <SectionHeader icon="bi-person-lines-fill" title="Contact Info" />
                            <InfoItem icon="bi-envelope" label="Email" value={userDetails.email_address} />
                            <InfoItem icon="bi-phone" label="Phone" value={`+91 ${userDetails.whatsapp_mobile_number}`} />

                            {/* Service Info */}
                            {userDetails.service_name !== "" && (
                                <InfoItem icon="bi-briefcase" label="Service" value={userDetails.service_name } />
                            )}

                            {/* Location Info */}
                            <SectionHeader icon="bi-geo-alt" title="Location" />
                            <InfoItem icon="bi-building" label="City" value={userDetails.city || 'N/A'} /> 
                            <InfoItem icon="bi-map" label="State" value={userDetails.state || 'N/A'} />

                            {/* Documents Section */}
                            <SectionHeader icon="bi-file-earmark-text" title="Documents" />
                            {userDetails.documents && userDetails.documents.length > 0 ? (
                              <div className="row g-3">
                                {userDetails.documents.map((doc, index) => (
                                  <div key={index} className="col-12 col-md-4">
                                  <div className="document-thumbnail d-flex justify-content-center align-items-center flex-column">
                                    <img
                                      src={userDetails.assetUrl + doc.document_url}
                                      alt={doc.name}
                                      className="img-fluid rounded-3 shadow-sm"
                                      style={{ maxHeight: '120px', objectFit: 'cover', cursor: 'pointer' }}
                                      onClick={() => handleImageClick(userDetails.assetUrl + doc.document_url)}
                                    />
                                    <div className="document-info mt-2 text-center">
                                      <h6 className="text-truncate" style={{ fontSize: '0.875rem' }}>{doc.name}</h6>
                                    </div>
                                  </div>
                                </div>
                                ))}
                              </div> 
                            ) : (
                              <div className="col-12">
                                <div className="alert alert-danger" role="alert">
                                  No documents available.
                                </div>
                              </div>
                            )}  

                            {/* Payment Details Section */}
                            {/* <SectionHeader icon="bi-credit-card" title="Payment Details" />
                            {paymentDetails?.payment != null ? (
                              <InfoItem icon="bi-building" label="Payment" value={paymentDetails?.payment} />
                            ) : (
                              <div className="col-12">
                                <div className="alert alert-warning" role="alert">
                                  User payment detail not found!
                                </div>
                              </div>
                            )} */}

                            {/* Subscription Details Section */}
                            <SectionHeader icon="bi-credit-card" title="Subscription Details" />
                              {subscriptionDetails?.subscriptionPlanActive ? (
                              <div className="card shadow-sm border-0 rounded-3 bg-light p-4 mt-2">
                                <h5 className="">Subscription Status</h5>
                                {/* Display status type */}
                                <div className="mb-3">
                                  <span className={`badge ${subscriptionDetails.statusType === 'SUCCESS' ? 'bg-success' : 'bg-danger'} text-white`}>
                                    active
                                  </span>
                                </div>
                                <div className="row">
                                  <div className="col-12 col-md-6">
                                    <p className="text-muted mb-1"><strong>Plan Name:</strong> {subscriptionDetails.subscriptionPlan.name}</p>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <p className="text-muted mb-1"><strong>Remaining Days:</strong> {subscriptionDetails.effectiveSubscriptionDays}</p>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    {/* <p className="text-muted mb-1"><strong>Duration (Days):</strong> {subscriptionDetails.subscriptionPlan.duration_in_days}</p> */}
                                    <p className="text-muted mb-1"><strong>Duration (Days):</strong> {subscriptionDetails.durationInDays}</p>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <p className="text-muted mb-1"><strong>Price:</strong> ₹{subscriptionDetails.subscriptionPlan.price}</p>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <p className="text-muted mb-1"><strong>GST:</strong> ₹{subscriptionDetails.subscriptionPlan.gst}</p>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <p className="text-muted mb-1"><strong>Total Price:</strong> ₹{subscriptionDetails.subscriptionPlan.total_price}</p>
                                  </div>
                                </div>
                                {/* <div className="mt-4">
                                  <button className="btn btn-primary">Manage Subscription</button>
                                </div> */}
                                      
                              </div>
                              ):(
                              <div className="col-12">
                                <div className="alert alert-warning" role="alert">
                                  No subscription plan active. 
                                </div>
                                {/* suggestion to subscribe */}
                                {/* <div className="mt-4">
                                  <button className="btn btn-primary">Subscribe Now</button>
                                </div> */}
                              </div>
                              )}

                          </div>
                        </div>

                        {/* buttons */}
                        <Row className="mt-4">
                          <Col xs={12}>
                            <ButtonGroup className="flex-wrap gap-2 pb-4 px-4">
                              <Link to="/partners" className="btn btn-primary d-flex align-items-center gap-2 ">
                                <FaArrowLeft />
                                Back
                              </Link> 
                              <Button
                                variant="outline-warning"
                                size="lg"
                                onClick={() => handleModalOpen("HOLD")}
                                className="d-flex align-items-center gap-2"
                              >
                                <FaPause />
                                Hold
                              </Button>

                              <Button
                                variant="outline-danger"
                                size="lg"
                                onClick={() => handleModalOpen("REJECT")}
                                className="d-flex align-items-center gap-2"
                              >
                                <FaTimes />
                                Reject
                              </Button>

                              {!userDetails?.active && (
                                <Button
                                  variant="outline-success"
                                  size="lg"
                                  onClick={() => handleModalOpen("APPROVE")}
                                  className="d-flex align-items-center gap-2"
                                >
                                  <FaCheck />
                                  Approve
                                </Button>
                              )}
                            </ButtonGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center text-muted py-5">Loading user details...</div>
                  )}

                  </div>
                  
                </Col>
              </Row>

              

              {/* Modal */}
              <Modal show={isModalOpen} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {modalAction === "APPROVE"
                      ? "Approve User"
                      : modalAction === "HOLD"
                      ? "Hold User"
                      : "Disable User"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Are you sure you want to {modalAction.toLowerCase()} this user?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleModalClose}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => handleApprove(modalAction)}
                  >
                    Confirm
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Modal for Zoomed Image */}
              <Modal
                show={showModal}
                onHide={handleClose}
                size="xl"
                centered
                dialogClassName="image-zoom-modal"
              >
                <Modal.Body className="p-0 bg-dark">
                  {selectedImage && (
                    <img
                      src={selectedImage}
                      alt="Zoomed document"
                      className="img-fluid w-100"
                    />
                  )}
                </Modal.Body>
              </Modal>
            </Container>
          </div>
      )}                    
    </>
  );
};

export default PartnerItem;


const SectionHeader = ({ icon, title }) => (
  <div className="col-12 mt-4">
    <h6 className="text-uppercase text-muted d-flex align-items-center gap-2">
      <i className={`bi ${icon}`}></i> {title}
    </h6>
    <hr className="my-2" />
  </div>
);

const InfoItem = ({ label, value, icon }) => (
  <div className="col-md-6">
    <div className="d-flex align-items-start gap-2">
      <i className={`bi ${icon} text-primary`} style={{ fontSize: '1rem' }}></i>
      <div>
        <div className="text-muted small">{label}</div>
        <div className="fw-semibold text-dark">{value}</div>
      </div>
    </div>
  </div>
);
